import isEmpty from "lodash/isEmpty";
import { RENDER_MESSAGE_TYPE_TABLE } from "../../constants";
import { MessageTypeConstants } from "../../../services/bot/Message";
import { showSnackbarV2 } from "../../actions/notification";
import store from "../../configureStore";
import { isArray, isObject } from "lodash";
import { renderNonconversationalFilter } from "../../actions/filters";


export const handleMessageTypeTable = (
    conversationId,
    message,
    isNewRow = false,
    promptOnClose = true
) => (dispatch) => {

    const tabStack = store.getState().tabStack || {};
    const existingTabData = tabStack[conversationId] || {};
    const hasTabs = !isEmpty(tabStack);

    let updatedTabData;

    if (hasTabs) {
        const hasAction = !!message?.options?.action;

        updatedTabData = hasAction
            ? handleActionBasedTabUpdate(existingTabData, message, isNewRow, promptOnClose)
            : updateTabDataWithoutAction(existingTabData, message, dispatch);

        if (!message.options?.updateInBackground && !hasAction) {
            updatedTabData.selectedTab = message.options.tabId;
        }

        dispatch({
            type: RENDER_MESSAGE_TYPE_TABLE,
            data: { [conversationId]: updatedTabData },
        });

    } else {
        const newData = {
            [conversationId]: {
                components: [message],
                ...(message.options?.updateInBackground ? {} : { selectedTab: message.options.tabId }),
            },
        };

        dispatch({
            type: RENDER_MESSAGE_TYPE_TABLE,
            data: newData,
        });
    }
};

export const handleActionBasedTabUpdate = (
    nonConversationalData,
    message,
    isNewRow,
    propmtOnClose
) => {
    const action = message?.options?.action;
    let updatedNonConversationalData;

    switch (action) {
        case "change": {
            updatedNonConversationalData = handleMessageTypeTableChangeAction(
                nonConversationalData,
                message,
                propmtOnClose,
                isNewRow
            );
            return updatedNonConversationalData;
        }
        case "validation":
        case "results": {
            updatedNonConversationalData =
                handleMessageTypeInlineFormTableResultAction(
                    nonConversationalData,
                    message
                );
            return updatedNonConversationalData;
        }
        case "changeColumnTemplate": {
            updatedNonConversationalData = handleMessageTypeTableChangeColumnTemplate(
                nonConversationalData,
                message
            );
            return updatedNonConversationalData;
        }
        case "clearRows": {
            updatedNonConversationalData = handleMessageTypeClearRows(
                nonConversationalData,
                message,
            )
            return updatedNonConversationalData
        }

        default:
            return nonConversationalData;
    }
};


const updateComponents = (components, message, promptOnClose, isNewRow) => {
    let updatedComponents = components.map((item) => {
        let prevItem = { ...item };

        const isMatchingParentDocId =
            prevItem?.options?.docId === message?.options?.parentDocId;
        const isMatchingTabId = prevItem?.options?.tabId === message?.options?.tabId;

        if (
            (prevItem?.options?.docId &&
                message?.options?.parentDocId &&
                isMatchingParentDocId) ||
            message?.options?.parent
        ) {
            if (prevItem?.options?.tabId && isMatchingTabId) {
                switch (prevItem.messageType) {
                    case MessageTypeConstants.MESSAGE_TYPE_CONTAINER:
                        prevItem.message = handleContainerMessageType(prevItem, message, false);
                        break;
                    case MessageTypeConstants.MESSAGE_TYPE_FORM2:
                        let newRows = message.message.update || message.message.change || null;
                        let newFields = message.message.fields || [];

                        const newOptions = message?.options || prevItem?.options

                        const message_sectionId = message?.options?.sectionId;
                        const message_docId = message?.options?.docId;

                        const relevantOptions = prevItem?.options;
                        const item_sectionId = relevantOptions?.sections?.[message_sectionId]?.sectionId;

                        const isMatchingSectionId = message_sectionId && item_sectionId && (message_sectionId === item_sectionId);
                        let rows = isMatchingSectionId ? prevItem.message.collectionData[message_sectionId].rows : prevItem.message;

                        const updatedRows = rows?.map(row => {
                            if (row.hasOwnProperty(message_docId)) {
                                return {
                                    [message_docId]: {
                                        ...row[message_docId],
                                        fields: newFields
                                    }
                                };
                            }
                            return row;
                        });

                        rows = handleOtherMessageTypes(rows, message);

                        if (isMatchingSectionId) {
                            prevItem = {
                                ...prevItem,
                                message: {
                                    ...prevItem.message,
                                    collectionData: {
                                        ...prevItem.message.collectionData,
                                        [message_sectionId]: {
                                            ...prevItem.message.collectionData[message_sectionId],
                                            rows: newRows ? newRows : updatedRows,
                                            ...(message.message.fields || message.message.update ? {} : { options: newOptions })
                                        }
                                    }
                                }
                            };
                        } else {
                            prevItem = {
                                ...prevItem,
                                message: newRows ? newRows : [...rows]
                            };
                        }
                        break;
                }
                prevItem.options.pages = message.options.pages;
            }
            if (promptOnClose !== undefined) {
                prevItem.options.promptOnClose = promptOnClose;
            }
        }

        else {
            if (
                prevItem?.options?.tabId &&
                message?.options?.tabId &&
                isMatchingTabId
            ) {
                let newRows = message.message.update || message.message.change || null;
                let newFields = message.message.fields || [];

                const newOptions = message?.options || prevItem?.options

                const message_sectionId = message?.options?.sectionId;
                const message_docId = message?.options?.docId;

                const relevantOptions = prevItem?.options;
                const item_sectionId = relevantOptions?.sections?.[message_sectionId]?.sectionId;

                const isMatchingSectionId = message_sectionId && item_sectionId && (message_sectionId === item_sectionId);

                switch (prevItem.messageType) {
                    case MessageTypeConstants.MESSAGE_TYPE_CALENDAR:
                        prevItem.message = handleCalendarMessageType(
                            prevItem,
                            message,
                            newRows
                        );
                        break;
                    case MessageTypeConstants.MESSAGE_TYPE_FORM2:
                    case MessageTypeConstants.MESSAGE_TYPE_TABLE:
                    case MessageTypeConstants.MESSAGE_TYPE_MAP:
                        let rows = isMatchingSectionId ? prevItem.message.collectionData[message_sectionId].rows : prevItem.message;

                        const updatedRows = rows?.map(row => {
                            if (row.hasOwnProperty(message_docId)) {
                                return {
                                    [message_docId]: {
                                        ...row[message_docId],
                                        fields: newFields
                                    }
                                };
                            }
                            return row;
                        });

                        rows = handleOtherMessageTypes(rows, message);

                        if (isMatchingSectionId) {
                            prevItem = {
                                ...prevItem,
                                message: {
                                    ...prevItem.message,
                                    collectionData: {
                                        ...prevItem.message.collectionData,
                                        [message_sectionId]: {
                                            ...prevItem.message.collectionData[message_sectionId],
                                            rows: newRows ? newRows : updatedRows,
                                            ...(message.message.fields || message.message.update ? {} : { options: newOptions })
                                        }
                                    }
                                }
                            };
                        } else {
                            prevItem = {
                                ...prevItem,
                                message: newRows ? newRows : [...rows]
                            };
                        }
                        break;
                    case MessageTypeConstants.MESSAGE_TYPE_CONTAINER: {
                        if (
                            !isNewRow &&
                            message?.options?.parent === null &&
                            !message?.message?.hasOwnProperty("append")
                        ) {
                            switch (prevItem.messageType) {
                                case MessageTypeConstants.MESSAGE_TYPE_CONTAINER:
                                    prevItem.message = handleContainerMessageType(prevItem, message, true);
                                    break;
                            }
                        }
                        else {
                            if (isArray(prevItem.message)) {
                                let preMessage = prevItem.message[0]?.message || {};

                                if (isObject(preMessage) && Object.keys(preMessage).length > 0) {
                                    const fields = preMessage.fields?.fields ?? [];
                                    const relevantOptions = preMessage.options ?? {};
                                    const collectionData = preMessage.fields?.collectionData ?? {};


                                    const message_sectionId = message?.options?.sectionId;
                                    const message_docId = message?.options?.docId;
                                    const item_sectionId = relevantOptions?.sections?.[message_sectionId]?.sectionId;

                                    const isMatchingSectionId =
                                        message_sectionId && item_sectionId && message_sectionId === item_sectionId;


                                    const shouldUpdateOptions = message.updateOptions ?? null;

                                    const sectionData = collectionData?.[message_sectionId];

                                    if (
                                        isMatchingSectionId &&
                                        sectionData &&
                                        Array.isArray(sectionData.rows)
                                    ) {
                                        const targetRowIndex = sectionData.rows.findIndex(
                                            row => Object.keys(row)[0] === message_docId
                                        );

                                        if (targetRowIndex !== -1) {
                                            const rowKey = Object.keys(sectionData.rows[targetRowIndex])[0];
                                            const rowData = sectionData.rows[targetRowIndex][rowKey];
                                            const existingRowOptions = rowData.rowOptions || {};
                                            const editRowValue = message?.options?.rowOptions?.editRow ?? false

                                            if (shouldUpdateOptions) {
                                                sectionData.rows[targetRowIndex][rowKey].rowOptions = {
                                                    ...existingRowOptions,
                                                    editRow: editRowValue
                                                };
                                            }

                                            // Save the updated structure
                                            prevItem.message[0].message = {
                                                ...preMessage,
                                                collectionData
                                            };
                                        } else {
                                            console.warn("Row with docId not found in section.");
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (promptOnClose !== undefined) {
                    prevItem.options.promptOnClose = promptOnClose;
                }
                prevItem.options.pages = message.options.pages;
            }
        }
        return prevItem;
    });

    return updatedComponents;
};


const handleContainerMessageType = (item, message, flag) => {
    const message_sectionId = message?.options?.sectionId;
    const msg = message?.message;
    const newRows = [...([msg?.update, msg?.change, msg?.fields].find(Array.isArray) || [])];
    const newOptions =
        typeof message?.options === 'object' && message?.options !== null
            ? message.options
            : {};

    const updatedMessages = Array.isArray(item.message)
        ? item.message.map((msg) => {
            let condition;
            if (flag) {
                condition =
                    message?.options &&
                    msg?.message?.options?.documentId === message?.options?.formId;
            } else {
                condition =
                    message?.options &&
                    msg?.message?.options?.tableId === message?.options?.tableId;
            }

            const item_sectionId =
                msg?.message?.options?.sections?.[message_sectionId]?.sectionId;
            const isMatchingSectionId =
                message_sectionId && item_sectionId && message_sectionId === item_sectionId;

            // === Handle section-specific update ===
            const collectionData = msg?.message?.fields?.collectionData;

            if (
                message_sectionId &&
                collectionData &&
                typeof collectionData === 'object' &&
                collectionData[message_sectionId]
            ) {
                const shouldUpdateOptions = message.updateOptions ?? null;

                if (shouldUpdateOptions) {
                    const sectionData = collectionData?.[message_sectionId];
                    if (isMatchingSectionId && Array.isArray(sectionData?.rows)) {
                        const message_docId = message?.options?.docId;
                        const targetRowIndex = sectionData.rows.findIndex(
                            (row) => Object.keys(row)[0] === message_docId
                        );

                        if (targetRowIndex !== -1) {
                            const rowKey = Object.keys(sectionData.rows[targetRowIndex])[0];
                            const rowData = sectionData.rows[targetRowIndex][rowKey];
                            const editRowValue = message?.options?.rowOptions?.editRow ?? false
                            const newFields = message?.message?.updatedOrNewfield ?? false

                            const updatedRow = {
                                ...rowData,
                                fields : [
                                    ...(message?.message?.fields || rowData?.fields) 
                                ],
                                rowOptions: {
                                    ...(rowData.rowOptions || {}),
                                    editRow: editRowValue
                                }
                            };

                            // Only replace that one row
                            const newRows = [...sectionData.rows];
                            newRows[targetRowIndex] = { [rowKey]: updatedRow };

                            return {
                                ...msg,
                                message: {
                                    ...msg.message,
                                    fields: {
                                        ...msg.message.fields,
                                        collectionData: {
                                            ...collectionData,
                                            [message_sectionId]: {
                                                ...sectionData,
                                                rows: newRows
                                            }
                                        }
                                    }
                                }
                            };
                        } else {
                            console.warn(`Row with docId '${message_docId}' not found in section.`);
                        }
                    } else {
                        console.warn("Invalid sectionData or section mismatch.");
                    }

                    // If we tried but failed, still return original msg unmodified
                    return msg;
                }


                // Default return if nothing was updated
                return {
                    ...msg,
                    message: {
                        ...msg.message,
                        fields: {
                            ...msg.message.fields,
                            collectionData: {
                                ...collectionData,
                                [message_sectionId]: {
                                    ...collectionData[message_sectionId],
                                    rows: newRows,
                                    ...(message.message.fields || message.message.update ? {} : { options: newOptions })
                                }
                            }
                        },
                        options: {
                            ...msg.message.options,
                            pages: message.options.pages
                        }
                    }
                };
            }

            // === Handle full message or table/form update ===
            if (condition || isMatchingSectionId) {
                let rows, updatedRows;
                if (isMatchingSectionId) {
                    rows = msg.message.collectionData?.[message_sectionId]?.rows || [];
                    updatedRows = handleOtherMessageTypes(rows, message);

                    return {
                        ...msg,
                        message: {
                            ...msg.message,
                            collectionData: {
                                ...msg.message.collectionData,
                                [message_sectionId]: {
                                    ...msg.message.collectionData[message_sectionId],
                                    rows: updatedRows
                                }
                            },
                            options: {
                                ...msg.message.options,
                                pages: message.options.pages
                            }
                        }
                    };
                } else {
                    rows = msg.message.rows;
                    updatedRows = handleOtherMessageTypes(rows, message);

                    return {
                        ...msg,
                        message: {
                            ...msg.message,
                            rows: updatedRows,
                            options: {
                                ...msg.message.options,
                                pages: message.options.pages,
                                ...(message.options?.emptyStateMessage
                                    ? { emptyStateMessage: message.options.emptyStateMessage }
                                    : {})
                            }
                        }
                    };
                }
            }

            // No change — return as-is
            return msg;
        })
        : item.message;

    return updatedMessages;
};


const handleCalendarMessageType = (item, message, newFields) => {
    if (message?.message?.update) {
        newFields = message?.message?.update;
    } else if (message?.message?.append) {
        newFields = item.message.concat(message.message.append);
    } else if (message?.message?.fields) {
        newFields = message?.message?.fields;
    }
    item.options.view = item.options.view || message?.options?.view || "month";
    item.options.style =
        item.options.style || message?.options?.style || "calendar";
    item.options.openDrawer = item.options.openDrawer || false;
    item.options.showFilterSearchInput =
        item.options.showFilterSearchInput || false;
    item.options.isNewFilter = item.options.isNewFilter || false;
    return newFields;
};

export const handleMessageTypeTableChangeAction = (
    tabStack,
    message,
    promptOnClose,
    isNewRow
) => {
    if (
        tabStack &&
        !isEmpty(tabStack) &&
        !isEmpty(tabStack.components)
    ) {
        const updatedComponents = updateComponents(
            tabStack.components,
            message,
            promptOnClose,
            isNewRow
        );
        let updatedNonConversationalData = {
            ...tabStack,
            components: updatedComponents,
        };
        return updatedNonConversationalData;
    }
    return tabStack;
};


const handleOtherMessageTypes = (rows, message) => {
    let updatedRows;
    if (message?.message?.deleteRow) {
        updatedRows = rows?.filter(
            (row) => !message.message.deleteRow.includes(Object.keys(row)[0])
        );
    } else if (message?.message?.change) {
        updatedRows = message.message.change;
    } else if (message?.message?.update) {
        updatedRows = message.message.update;
    } else if (message?.message?.remove) {
        updatedRows = removeFieldsFromRows(rows, message);
    } else if (message?.message?.append) {
        updatedRows = rows.concat(message.message.append);
    } else if (message?.message?.fields) {
        updatedRows = updateMessageFields(rows, message);
    } else {
        updatedRows = rows;
    }
    return updatedRows;
};


const removeFieldsFromRows = (rows, message) => {
    let updatedRows = [];

    rows.forEach(([docId, rowValue]) => {
        if (docId === message.options.docId) {
            let updatedRowValue = rowValue.filter(
                (field) => !message.message.remove.includes(field.id)
            );
            updatedRows.push({ [docId]: updatedRowValue });
        } else {
            updatedRows.push({ [docId]: rowValue });
        }
    });

    return updatedRows;
};

const updateMessageFields = (rows, message) => {
    let updatedMessage = [];

    rows.forEach((row) => {
        Object.entries(row).forEach(([docId, rowValue]) => {
            if (
                message?.options?.docId &&
                docId &&
                message?.options?.docId === docId
            ) {
                const updatedRowValue = updateRowFields(rowValue, message);
                updatedMessage.push({ [docId]: updatedRowValue });
            } else {
                updatedMessage.push({ [docId]: rowValue });
            }
        });
    });

    return updatedMessage;
};

const updateRowFields = (rowValue, message) => {
    let fieldsList = [];
    let updatedFields = [];

    rowValue.fields.forEach((field) => {
        fieldsList.push(field.id);

        const newField = message.message.fields.find((f) => f.id === field.id);
        if (newField) {
            updatedFields.push(newField);
        } else {
            updatedFields.push(field);
        }
    });

    const finalFields = addNewFields(updatedFields, message, fieldsList);
    let rowOptionsFromMessage = message?.options?.rowOptions && message?.options?.action == "change" ? message?.options?.rowOptions : rowValue.rowOptions
    return {
        ...rowValue,
        fields: finalFields,
        rowOptions: rowOptionsFromMessage
    };
};

const addNewFields = (fields, message, fieldsList) => {
    let newFields = [];

    message.message.fields.forEach((newField) => {
        if (!fieldsList.includes(newField.id)) {
            newFields.push(newField);
        }
    });

    newFields = newFields.concat(fields);

    if (newFields.find((field) => field.index)) {
        newFields.sort((a, b) =>
            a.index > b.index ? 1 : b.index > a.index ? -1 : 0
        );
    }

    return newFields;
};


export const updateTabDataWithoutAction = (tabData, message, dispatch) => {
    const hasComponents = Array.isArray(tabData?.components) && tabData.components.length > 0;

    const getOptionOrDefault = (key, fallback) =>
        message.options?.hasOwnProperty(key) ? message.options[key] : fallback;

    const view = getOptionOrDefault("view", "month");
    const style = getOptionOrDefault("style", "calendar");
    const openDrawer = getOptionOrDefault("openDrawer", false);
    const showFilterSearchInput = getOptionOrDefault("showFilterSearchInput", false);
    const isNewFilter = getOptionOrDefault("isNewFilter", false);

    let updatedComponents = [];

    if (hasComponents) {
        const tabIds = tabData.components.map(comp => comp.options?.tabId);
        const filtedtabComponents = tabData.components.filter((data) => !data.hidden);

        updatedComponents = filtedtabComponents.map((component) => {
            const isSameTab = component.options?.tabId === message.options?.tabId
            const message_sectionId = message?.options?.sectionId;

            const sectionId = message?.options?.sectionId;

            if (isSameTab) {
                let updatedComponent

                // if (message_sectionId) {
                //     const sectionExists = component?.message?.some((item) =>
                //         item?.options?.sections && Object.keys(item.options.sections).includes(sectionId)
                //     );

                //     if (sectionExists) {
                //         console.log("Section Exists:", sectionExists);
                //     }
                //     else {
                //         console.log("Section not exist then return previous :", sectionExists);
                //         return component;
                //     }
                // }
                // else {
                updatedComponent = {
                    ...message,
                    options: {
                        ...message.options,
                        view: component.options?.view,
                        style: component.options?.style,
                        openDrawer,
                        showFilterSearchInput,
                        isNewFilter,
                    },
                };

                if (updatedComponent.options.openDrawer) {
                    dispatch(renderNonconversationalFilter(updatedComponent));
                }
                // }

                return updatedComponent;
            }

            return component;
        });

        if (!tabIds.includes(message.options?.tabId)) {
            updatedComponents.push({
                ...message,
                options: {
                    ...message.options,
                    view,
                    style,
                    openDrawer,
                    showFilterSearchInput,
                    isNewFilter,
                },
            });
        }

    } else {
        updatedComponents = [message];
    }

    return {
        ...tabData,
        components: updatedComponents,
    };
};


export const handleMessageTypeInlineFormTableResultAction = (tabStackData, message, promptOnClose) => {
    if (tabStackData && !isEmpty(tabStackData) && !isEmpty(tabStackData.components)) {
        // Create a new array of components by mapping through the original components array
        const updatedComponents = tabStackData.components.map((item) => {
            if (
                item?.options?.docId &&
                message?.options?.parentDocId &&
                item?.options?.docId === message?.options?.parentDocId
            ) {
                // Return a new item object returned by the function instead of modifying the existing item object
                return processMessageWithParent(item, message, promptOnClose);
            } else {
                // Return a new item object returned by the function instead of modifying the existing item object
                return processMessageWithoutParent(item, message, promptOnClose);
            }
        });

        // Return a new object with updated components, preserving other properties of tabStackData
        return {
            ...tabStackData,
            components: updatedComponents
        };
    }
    // If the conditions aren't met, return the original object
    return tabStackData;
};


export const processMessageWithParent = (item, message, promptOnClose) => {
    let updatedItem = { ...item };

    if (message.message.field) {
        if (Array.isArray(item.message)) {
            updatedItem.message = item.message.map((msg) => {
                let updatedMsg = { ...msg };
                let sectionId = message?.options?.sectionId;
                let sectionCollectionData = msg?.message?.collectionData?.[sectionId];

                if (msg?.message?.options?.tableId === message?.options?.tableId) {
                    updatedMsg.message.rows = processRows(msg.message.rows, message);
                } else if (sectionId && sectionCollectionData != null) {
                    let rows = sectionCollectionData?.rows;
                    if (Array.isArray(rows)) {
                        let updatedRows = processRows(rows, message);
                        updatedMsg.message = {
                            ...updatedMsg.message,
                            collectionData: {
                                ...updatedMsg.message.collectionData,
                                [sectionId]: {
                                    ...sectionCollectionData,
                                    rows: updatedRows
                                }
                            }
                        };
                    }
                }

                return updatedMsg;
            });
        }
    } else {
        updatedItem = processGenericError(updatedItem, message);
    }

    updatedItem = setPromptOnClose(updatedItem, promptOnClose);

    return updatedItem;
};

export const processMessageWithoutParent = (item, message, promptOnClose) => {
    let updatedItem = { ...item };

    if (message.message.field) {
        let sectionId = message?.options?.sectionId;
        let sectionCollectionData = item?.message?.collectionData?.[sectionId];

        if (item?.options?.tableId === message?.options?.tableId) {
            Array.isArray(item.message) && (updatedItem.message = processRows(item.message, message));
        } else if (sectionId && sectionCollectionData != null) {
            let rows = sectionCollectionData?.rows;
            if (Array.isArray(rows)) {
                let updatedRows = processRows(rows, message);
                // Deep copy to ensure immutability at all levels of nested objects
                updatedItem.message = {
                    ...updatedItem.message,
                    collectionData: {
                        ...updatedItem.message.collectionData,
                        [sectionId]: {
                            ...sectionCollectionData,
                            rows: updatedRows
                        }
                    }
                };
            }
        }
    } else {
        updatedItem = processGenericError(updatedItem, message);
    }

    updatedItem = setPromptOnClose(updatedItem, promptOnClose);

    return updatedItem;
};


const processRows = (rows, message) => {
    let updatedRows = rows.map((row) => {
        let updatedRow = {};
        Object.entries(row).forEach(([docId, fieldsObject]) => {
            if (message?.options?.docId === docId) {
                updatedRow[docId] = {
                    ...fieldsObject,
                    fields: fieldsObject.fields.map((field) => {
                        return updateField(field, message);
                    }),
                };
            } else {
                updatedRow[docId] = fieldsObject;
            }
        });
        return updatedRow;
    });

    return updatedRows;
};


const updateField = (field, message) => {
    if (field.id === message?.message?.field) {
        return {
            ...field,
            results: message?.message?.results,
            validationResult: message?.message?.validationResult,
            validationMessage: message?.message?.validationMessage,
        };
    }
    return field;
};


const processGenericError = (item, message) => {
    const updatedItem = {
        ...item,
        genericError: message.message,
    };

    if (!message.message.validationResult) {
        store.dispatch(
            showSnackbarV2("error", message.message.validationMessage)
        );
    }

    return updatedItem;
};


const setPromptOnClose = (item, promptOnClose) => {
    if (promptOnClose !== undefined) {
        return {
            ...item,
            options: {
                ...item.options,
                promptOnClose: promptOnClose
            }
        };
    }
    return item;
};


export const handleMessageTypeTableChangeColumnTemplate = (tabStackData, message, promptOnClose) => {
    if (
        tabStackData &&
        !isEmpty(tabStackData) &&
        !isEmpty(tabStackData.components)
    ) {
        const updatedComponents = tabStackData.components.map((item) => {
            let updatedItem = { ...item };

            if (
                updatedItem?.options?.docId &&
                message?.options?.parentDocId &&
                updatedItem?.options?.docId === message?.options?.parentDocId
            ) {
                if (
                    updatedItem?.options?.tabId &&
                    updatedItem?.options?.tabId === message?.options?.tabId
                ) {
                    switch (updatedItem.messageType) {
                        case MessageTypeConstants.MESSAGE_TYPE_CONTAINER:
                            updatedItem.message = updatedItem.message.map((msg) => {
                                if (
                                    message?.options &&
                                    msg?.message?.options?.tableId === message?.options?.tableId
                                ) {
                                    if (message.options.columnTemplate) {
                                        return {
                                            ...msg,
                                            message: {
                                                ...msg.message,
                                                options: {
                                                    ...msg.message.options,
                                                    columnTemplate: message.options.columnTemplate,
                                                },
                                            },
                                        };
                                    }
                                }
                                return msg;
                            });
                            break;
                    }
                }

                if (promptOnClose !== undefined) {
                    updatedItem = {
                        ...updatedItem,
                        options: {
                            ...updatedItem.options,
                            promptOnClose: promptOnClose
                        }
                    };
                }
            } else {
                if (
                    updatedItem?.options?.tabId &&
                    message?.options?.tabId &&
                    updatedItem?.options?.tabId === message?.options?.tabId
                ) {
                    switch (updatedItem.messageType) {
                        case MessageTypeConstants.MESSAGE_TYPE_CALENDAR:
                        case MessageTypeConstants.MESSAGE_TYPE_FORM2:
                        case MessageTypeConstants.MESSAGE_TYPE_TABLE:
                            if (message.options.columnTemplate) {
                                updatedItem = {
                                    ...updatedItem,
                                    options: {
                                        ...updatedItem.options,
                                        columnTemplate: message.options.columnTemplate,
                                    },
                                };
                            }
                            break;
                    }

                    if (promptOnClose !== undefined) {
                        updatedItem = {
                            ...updatedItem,
                            options: {
                                ...updatedItem.options,
                                promptOnClose: promptOnClose
                            }
                        };
                    }
                }
            }
            return updatedItem;
        });

        const updatedTabStackData = {
            ...tabStackData,
            components: updatedComponents,
        };

        return updatedTabStackData;
    }

    return tabStackData;
};


export const handleMessageTypeClearRows = (tabStackData, message) => {
    const { controlId: messageControlId,
        documentId: messageDocumentId,
        sectionId: messageSectionId } = message.options;


    const updatedComponents = tabStackData?.components?.map(component => {
        const { controlId: componentControlId, documentId: componentDocumentId } = component?.options || {};

        let updatedComponent = { ...component };

        if (componentControlId === messageControlId && componentDocumentId === messageDocumentId) {
            updatedComponent = { ...updatedComponent, message: [] };
        }


        if (component?.message?.collectionData) {
            let collectionDataUpdated = false;
            const updatedCollectionData = { ...component.message.collectionData };

            Object.keys(updatedCollectionData).map(key => {
                if (updatedCollectionData[key]?.options?.sectionId === messageSectionId) {
                    collectionDataUpdated = true;
                    updatedCollectionData[key] = {
                        ...updatedCollectionData[key], rows: []
                    };

                }
            });

            if (collectionDataUpdated) {
                updatedComponent = {
                    ...updatedComponent,
                    message: {
                        ...updatedComponent.message,
                        collectionData: updatedCollectionData
                    }
                };
            }
        }
        if (Array.isArray(component?.message) && component.message[0]?.type === "form2") {
            const updatedMessageArray = component.message.map(messageItem => {
                if (messageItem?.type === "form2") {
                    let collectionDataUpdated = false;
                    const updatedCollectionData = {
                        ...messageItem.message.collectionData
                    };
                    Object.keys(updatedCollectionData).map(key => {
                        if (updatedCollectionData[key]?.options?.sectionId === messageSectionId) {
                            collectionDataUpdated = true;
                            updatedCollectionData[key] = {
                                ...updatedCollectionData[key],
                                rows: []
                            };
                        }
                    });

                    if (collectionDataUpdated) {
                        return {
                            ...messageItem,
                            message: {
                                ...messageItem.message,
                                collectionData: updatedCollectionData
                            }
                        };
                    }
                }
                return messageItem;
            });

            updatedComponent = {
                ...updatedComponent,
                message: updatedMessageArray
            };
        }


        return updatedComponent;
    });


    const updatedTabStackData = {
        ...tabStackData,
        components: updatedComponents
    };

    return updatedTabStackData;
};